import { render, staticRenderFns } from "./error.vue?vue&type=template&id=1bb580cd&scoped=true&lang=pug&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb580cd",
  null
  
)

export default component.exports